import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { apiRequest } from '../authConfig.js';
import { adminGetUsers } from '../api.js';

/**
 * ProtectedRoute — guards a route behind admin verification.
 *
 * The admin check is performed against the backend (not just the JWT claim),
 * so the server-side guard is the authoritative source of truth.
 */
export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { instance, accounts } = useMsal();
  const [status, setStatus] = useState('checking'); // 'checking' | 'allowed' | 'denied'

  useEffect(() => {
    if (!requireAdmin) {
      setStatus('allowed');
      return;
    }

    const account = accounts[0];
    if (!account) {
      setStatus('denied');
      return;
    }

    instance
      .acquireTokenSilent({ ...apiRequest, account })
      .then((resp) => adminGetUsers(resp.idToken))
      .then(() => setStatus('allowed'))
      .catch(() => setStatus('denied'));
  }, [instance, accounts, requireAdmin]);

  if (status === 'checking') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
        <p>A verificar permissões...</p>
      </div>
    );
  }

  if (status === 'denied') {
    return <Navigate to="/" replace />;
  }

  return children;
}
